export enum PSelectCardVariant {
  WHITE = 'white',
  GRAY = 'gray',
}
